import styled from 'styled-components';
import { spacing } from 'ui/theme';
import { ModuleHeader } from '../../lib/components/Module';
import { Filters } from './Filters';
import { LAUNCHPAD_TEST_IDS } from './Launchpad.constants';
import { LaunchpadState } from './Launchpad.types';

const StyledModuleHeader = styled(ModuleHeader)`
  margin-top: ${spacing.threeQuarter};
`;

export const LaunchpadHeader = ({
  isLoadingState,
  isEmptyState,
  isErrorState,
  isZeroState,
  isDataState,
}: LaunchpadState) => {
  if (isEmptyState || isErrorState) return null;

  return (
    <StyledModuleHeader
      data-test={LAUNCHPAD_TEST_IDS.HEADER}
      isLoading={isLoadingState}
      title={'Jump back in'}
    >
      {(isDataState || isZeroState) && <Filters />}
    </StyledModuleHeader>
  );
};
